import { render, staticRenderFns } from "./SimTaskDetail.vue?vue&type=template&id=c1b33250&scoped=true"
import script from "./SimTaskDetail.vue?vue&type=script&lang=js"
export * from "./SimTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./SimTaskDetail.vue?vue&type=style&index=0&id=c1b33250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b33250",
  null
  
)

export default component.exports